// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LegalDocumentContent > h1 {
  font-size: 1.8rem;
  font-weight: 500;
  margin-top: 3rem;
  margin-bottom: 1.42rem;
  border-top: 1px solid #eee;
  padding-top: 2.5rem;
}

.LegalDocumentContent > h1:first-child {
  border: none;
  margin-top: 0;
  padding-top: 0;
}

.LegalDocumentContent > h2 {
  min-height: 0;
  padding: 0;
  margin-top: 3rem;
  margin-bottom: 1.42rem;
  font-weight: 500;
  font-size: 1.42rem;
}

.LegalDocumentContent strong {
  font-weight: 600;
}

.LegalDocumentContent p {
  font-size: 1rem;
  margin: 0 0 10px;
  line-height: 1.428;
}

.LegalDocumentContent ul {
  list-style: disc;
  padding-left: 2rem;
  line-height: 1.428;
  margin-bottom: 1rem;
}

.LegalDocumentContent ol {
  list-style: decimal;
  padding-left: 2rem;
  line-height: 1.428;
  margin-bottom: 1rem;
}

.LegalDocumentContent table,
.LegalDocumentContent th,
.LegalDocumentContent td {
  border-width: 1px;
  border-style: solid;
  border-color: lightgrey;
  border-image: initial;
  word-break: break-word;
}

.LegalDocumentContent table {
  margin-bottom: 1rem;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
  width: 99%;
}

.LegalDocumentContent th {
  background: #f4f4f4;
}

.LegalDocumentContent td {
  vertical-align: top;
}

.LegalDocumentContent td,
.LegalDocumentContent th {
  padding: 1rem;
  width: 50%;
}
`, "",{"version":3,"sources":["webpack://./js/components/LegalDocument/LegalDocumentContent.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;EAGE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,UAAU;AACZ","sourcesContent":[".LegalDocumentContent > h1 {\n  font-size: 1.8rem;\n  font-weight: 500;\n  margin-top: 3rem;\n  margin-bottom: 1.42rem;\n  border-top: 1px solid #eee;\n  padding-top: 2.5rem;\n}\n\n.LegalDocumentContent > h1:first-child {\n  border: none;\n  margin-top: 0;\n  padding-top: 0;\n}\n\n.LegalDocumentContent > h2 {\n  min-height: 0;\n  padding: 0;\n  margin-top: 3rem;\n  margin-bottom: 1.42rem;\n  font-weight: 500;\n  font-size: 1.42rem;\n}\n\n.LegalDocumentContent strong {\n  font-weight: 600;\n}\n\n.LegalDocumentContent p {\n  font-size: 1rem;\n  margin: 0 0 10px;\n  line-height: 1.428;\n}\n\n.LegalDocumentContent ul {\n  list-style: disc;\n  padding-left: 2rem;\n  line-height: 1.428;\n  margin-bottom: 1rem;\n}\n\n.LegalDocumentContent ol {\n  list-style: decimal;\n  padding-left: 2rem;\n  line-height: 1.428;\n  margin-bottom: 1rem;\n}\n\n.LegalDocumentContent table,\n.LegalDocumentContent th,\n.LegalDocumentContent td {\n  border-width: 1px;\n  border-style: solid;\n  border-color: lightgrey;\n  border-image: initial;\n  word-break: break-word;\n}\n\n.LegalDocumentContent table {\n  margin-bottom: 1rem;\n  border-collapse: collapse;\n  border-spacing: 0;\n  table-layout: fixed;\n  width: 99%;\n}\n\n.LegalDocumentContent th {\n  background: #f4f4f4;\n}\n\n.LegalDocumentContent td {\n  vertical-align: top;\n}\n\n.LegalDocumentContent td,\n.LegalDocumentContent th {\n  padding: 1rem;\n  width: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
